// extracted by mini-css-extract-plugin
export default {"productFeatured":"Jca-z","carousel":"Kca-z","slides":"Lca-z","slide":"Mca-z","slideFeatured":"Nca-z","zoomMode":"Oca-z","fadeIn":"Pca-z","imageSizing":"Qca-z"};